module.exports = __webpack_public_path__ + "img/Stiv.932849d6.gif";